module.exports = __webpack_public_path__ + "static/media/robot1.4738898c.gif";